import CategoryPage from "@/pages/category/components/CategoryPage";
import { getArticlesByCategory } from "@/mocks/articles";

export default function YouxiZixun() {
  return (
    <CategoryPage
      categorySlug="youxi-zixun"
      metaTitle="游戏资讯 - 热门游戏快讯与动态 | 可游漫画网"
      metaDesc="可游漫画网游戏资讯栏目，汇聚热门游戏一手快讯、版本动态与活动情报，第一时间掌握游戏资讯与漫画化联动内容。"
      heading="游戏资讯"
      kicker="一手快讯"
      articles={getArticlesByCategory("youxi-zixun")}
    />
  );
}